//noinspection JSValidateTypes
export default angular.module("sentenceCaseFilter", [])
  .filter("sentence_case", sentenceCaseFilter)
  .name;

const $inject = ["TextService"];

function sentenceCaseFilter(TextService) {
  return function (text) {
    return TextService.to_sentence_case(text);
  };
}

sentenceCaseFilter.$inject = $inject;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/filters/sentence-case.filter.js
 **/